import React, { useEffect, useRef, useState } from 'react';

// Wrapper component to suppress React 19 findDOMNode warnings from ReactQuill
let ReactQuill;

const RichTextEditor = ({ value, onChange, placeholder, style, modules }) => {
  const editorRef = useRef(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // Suppress the findDOMNode deprecation warning
    const originalError = console.error;
    console.error = (...args) => {
      if (
        typeof args[0] === 'string' &&
        (args[0].includes('findDOMNode') || args[0].includes('ReactDOM.findDOMNode'))
      ) {
        return;
      }
      originalError.call(console, ...args);
    };

    // Import ReactQuill
    import('react-quill').then((mod) => {
      ReactQuill = mod.default;
      import('react-quill/dist/quill.snow.css');
      setMounted(true);
    });

    return () => {
      console.error = originalError;
    };
  }, []);

  if (!mounted || !ReactQuill) {
    return (
      <div 
        style={{ 
          ...style, 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          backgroundColor: '#f9f9f9',
          border: '1px solid #ddd',
          borderRadius: '4px'
        }}
      >
        <span style={{ color: '#999' }}>Loading editor...</span>
      </div>
    );
  }

  return (
    <ReactQuill
      ref={editorRef}
      theme="snow"
      value={value}
      onChange={onChange}
      modules={modules}
      placeholder={placeholder}
      style={style}
    />
  );
};

export default RichTextEditor;
